import React, { Component } from 'react';
import { Col } from 'react-bootstrap';
import HealthIndexFeeder from './HealthIndexFeeder';

export default class Details extends Component {
  constructor(props) {
    super(props);
    this.state = {
      criticalityIndexVsHealthIndex: this.props.criticalityIndexVsHealthIndex,
      selectedSubStation: this.props.selectedSubStation,
      selectedYear: this.props.selectedYear,
      feederVsHealthIndex: this.props.feederVsHealthIndex,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    // this.props.onActive();
    this.setState({
      criticalityIndexVsHealthIndex: nextProps.criticalityIndexVsHealthIndex,
      selectedSubStation: nextProps.selectedSubStation,
      feederVsHealthIndex: nextProps.feederVsHealthIndex,
      selectedYear: nextProps.selectedYear,
    });
  }

  showIndex(cVal, hVal) {
    const obj = {
      CI: cVal,
      HI: hVal,
    };
    this.props.onCableHealthBoxClick(obj);
  }

  render() {
    const { criticalityIndexVsHealthIndex, feederVsHealthIndex } = this.state;
    return (
      <div style={{ maxHeight: '65vh', overflowY: 'auto' }}>
        <Col md={12} className="detail-box">
          <div>
            <div>
              <h4
                className="text-center"
                style={{
                  color: '#333333',
                  fontSize: '16px',
                  fill: '#333333',
                  borderLeft: 'none !important',
                  fontFamily:
                    '"Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif',
                }}
              >
                {'Cable Health Data'}
              </h4>
              <br />
            </div>
            <div>
              <table className="table table-borderless table-condensed">
                <thead>
                  <tr>
                    <th className="no-border" style={{ fontSize: '22px' }}></th>
                    <th className="no-border" style={{ fontSize: '22px' }}>
                      HI1
                    </th>
                    <th className="no-border" style={{ fontSize: '22px' }}>
                      HI2
                    </th>
                    <th className="no-border" style={{ fontSize: '22px' }}>
                      HI3
                    </th>
                    <th className="no-border" style={{ fontSize: '22px' }}>
                      HI4
                    </th>
                    <th className="no-border" style={{ fontSize: '22px' }}>
                      HI5
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {criticalityIndexVsHealthIndex.map((ci, index) => (
                    <tr key={index}>
                      <th
                        className="no-border"
                        style={{
                          backgroundColor: ci.CIRowColor,
                          fontSize: '22px',
                          cursor: 'pointer',
                        }}
                      >
                        {ci.CI}
                      </th>
                      <td
                        onClick={this.showIndex.bind(
                          this,
                          `C${index + 1}`,
                          'HI1'
                        )}
                        className="no-border"
                        style={{
                          backgroundColor: ci.HI1Color,
                          fontSize: '22px',
                          cursor: 'pointer',
                        }}
                      >
                        {ci.HI1}
                      </td>
                      <td
                        onClick={this.showIndex.bind(
                          this,
                          `C${index + 1}`,
                          'HI2'
                        )}
                        className="no-border"
                        style={{
                          backgroundColor: ci.HI2Color,
                          fontSize: '22px',
                          cursor: 'pointer',
                        }}
                      >
                        {ci.HI2}
                      </td>
                      <td
                        onClick={this.showIndex.bind(
                          this,
                          `C${index + 1}`,
                          'HI3'
                        )}
                        className="no-border"
                        style={{
                          backgroundColor: ci.HI3Color,
                          fontSize: '22px',
                          cursor: 'pointer',
                        }}
                      >
                        {ci.HI3}
                      </td>
                      <td
                        onClick={this.showIndex.bind(
                          this,
                          `C${index + 1}`,
                          'HI4'
                        )}
                        className="no-border"
                        style={{
                          backgroundColor: ci.HI4Color,
                          fontSize: '22px',
                          cursor: 'pointer',
                        }}
                      >
                        {ci.HI4}
                      </td>
                      <td
                        onClick={this.showIndex.bind(
                          this,
                          `C${index + 1}`,
                          'HI5'
                        )}
                        className="no-border"
                        style={{
                          backgroundColor: ci.HI5Color,
                          fontSize: '22px',
                          cursor: 'pointer',
                        }}
                      >
                        {ci.HI5}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <span className="divider"></span>
            <HealthIndexFeeder data={feederVsHealthIndex}></HealthIndexFeeder>
            <div className="text-center">
              <i>Health Index requires 10 years data for highest accuracy</i>
            </div>
          </div>
        </Col>
      </div>
    );
  }
}
